module.exports = __webpack_public_path__ + "static/media/art42.bb6edba1.jpg";